import BundleSelection from "../components/bundle";

const Product = {
  $sectionProduct: $("[data-section-product]"),
  $wrapperImages: $("[data-section-product]").find("[data-product-images]"),
  $sliderProduct: $("[data-section-product]").find(
    "[data-product-images] [data-main-slider]"
  ),
  $thumbsProduct: $("[data-section-product]").find(
    "[data-product-images] [data-slider-thumbs]"
  ),
  sliderProduct: [],
  sliderZoom: [],
  showFirstImages: function () {
    var _this = this;
    var variants = vnda.variants.all();
    var $imagesWithoutSkus = _this.$sliderProduct.find(".image-without-sku");
    var $thumbsWithoutSkus = _this.$thumbsProduct.find(".image-without-sku");

    if ($imagesWithoutSkus.length > 0) {
      /*
          Todas as imagens sem skus são exibidas sempre
        */

      $imagesWithoutSkus.removeClass("inactive").addClass("active");

      $thumbsWithoutSkus.removeClass("inactive").addClass("active");
    } else {
      /*
          Percorre todas as variantes
        */
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].main) {
          //console.info(variants[i]);

          // Procura a imagem que contém o sku e a exibe
          _this.$sliderProduct
            .find('[data-image][data-skus-image*="' + variants[i].sku + '"]')
            .addClass("active")
            .removeClass("inactive");

          _this.$thumbsProduct
            .find(
              '[data-image-thumb][data-skus-image*="' + variants[i].sku + '"]'
            )
            .addClass("active")
            .removeClass("inactive");
        }
      }
    }
  },
  setGallery: function () {
    var _this = this;

    var gallery = new Swiper(_this.$sliderProduct, {
      slidesPerView: 1,
      spaceBetween: 0,
      watchOverflow: true,
      simulateTouch: false,
      navigation: {
        nextEl: $(".wrapper-slider .swiper-navigation.-next"),
        prevEl: $(".wrapper-slider .swiper-navigation.-prev"),
        disabledClass: "-disabled",
      },
      breakpoints: {
        768: {
          spaceBetween: 10,
        },
      },
      //swiper lazy load
      preloadImages: false,
      watchVisibility: true,
      lazy: {
        checkInView: true,
        loadOnTransitionStart: true,
        loadPrevNext: false,
      },
    });

    var galleryThumbs = new Swiper(_this.$thumbsProduct, {
      spaceBetween: 10,
      slidesPerView: 4,
      freeMode: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      simulateTouch: true,
      watchOverflow: true,
      navigation: {
        nextEl: $(".wrapper-thumbs .swiper-navigation"),
        disabledClass: "-disabled",
      },
    });

    this.sliderProduct.push(gallery);
    this.sliderProduct.push(galleryThumbs);

    $("[data-image-thumb]").on("click", function () {
      //console.log('oie');
      //console.log($(this).data('index'));
      gallery.slideTo($(this).data("index"));
    });
  },
  handleExternal: function () {
    var $body = $('body');
    if ($body.width() <= 767) {
      $(".external-anchor").on("click", () => {
        $wrapper_external = $(".wrapper-external");

        $wrapper_external.hasClass("active")
          ? $wrapper_external.removeClass("active")
          : $wrapper_external.addClass("active");
      });
    }
  },
  handleZoom: function () {
    const _this = this;
    var $body = $('body');
    // handle open
    $("[data-zoom-open]").on("click", function () {
      $(".zoom-images").addClass("active");
      $index = $(this).data("zoom-open");
      _this.sliderZoom[0].slideTo($index);
    });
    // handle close
    $("[data-zoom-close]").on("click", () => {
      $(".zoom-images").removeClass("active");
    });
    // handle esc
    $(document).keyup(function (e) {
      if (e.key === "Escape") {
        $(".zoom-images").removeClass("active");
      }
    });
    // set controls width
    if ($body.width() > 767) {
      $(".images-control").width($(".images-control").height());
    }
  },
  setZoomSwiper: function () {
    const zoomSlider = document.querySelectorAll("[data-swiper-zoom]");

    if (zoomSlider.length > 0) {
      zoomSlider.forEach((zoom) => {
        const zoomSwiper = new Swiper(zoom, {
          watchOverflow: true,
          slidesPerView: 1,
          spaceBetween: 0,
          speed: 1000,
          navigation: {
            nextEl: $(".zoom-images .swiper-navigation.-next"),
            prevEl: $(".zoom-images .swiper-navigation.-prev"),
            disabledClass: "-disabled",
          },
          //swiper lazy load
          preloadImages: false,
          watchVisibility: true,
          lazy: {
            loadPrevNext: true,
            Amount: 1,
            loadOnTransitionStart: true,
          },
        });

        this.sliderZoom.push(zoomSwiper);
      });
    }
  },
  setRelatedSwiper: function () {
    const relatedSlider = document.querySelectorAll("[data-swiper-related]");

    if (relatedSlider.length > 0) {
      relatedSlider.forEach((related) => {
        const pagination = related.querySelector(".swiper-pagination");

        const relatedSwiper = new Swiper(related, {
          watchOverflow: true,
          loop: false,
          slidesPerView: 2,
          spaceBetween: 15,
          speed: 1000,
          breakpoints: {
            768: {
              slidesPerView: 3,
            },
            992: {
              slidesPerView: 4,
            },
          },
          navigation: {
            nextEl: $(".section-related .swiper-navigation.-next .icon"),
            prevEl: $(".section-related .swiper-navigation.-prev .icon"),
            disabledClass: "-disabled",
          },
          //swiper lazy load
          preloadImages: false,
          watchVisibility: true,
          lazy: {
            loadPrevNext: true,
            Amount: 1,
            loadOnTransitionStart: true,
          },
        });

        // set navigation height
        window.addEventListener("load", () => {
          $swiper_navigation = $(related).parent().find(".swiper-navigation");
          $height = $(related).find(".wrapper-images img").height();

          $swiper_navigation.height($height);
        });
      });
    }
  },
  init: function () {
    const _this = this;

    _this.showFirstImages();
    _this.setGallery();
    _this.handleExternal();
    _this.setZoomSwiper();
    _this.handleZoom();
    _this.setRelatedSwiper();

    BundleSelection.handleBundleSubmit();

    $("[data-form-notify-button]").on("click", function () {
      $("[data-form-notify-content]").toggleClass("active");
    });
  },
};

window.addEventListener("DOMContentLoaded", () => {
  Product.init();
});
